import { adaptCategories } from './utils';

export const commentConfig = [
  {
    name: 'sentiment',
    type: 'sentimentCreator',
    displayName: 'Choose sentiment for answer',
    category: 'Sentiment',
  },
  {
    name: 'isInReport:switch',
    displayName: 'Should question be visible in Report?',
    default: false,
    category: 'Reports',
  },
  {
    name: 'mainChart',
    displayName: 'Choose Main chart',
    choices: ['none', 'open-question'],
    default: 'none',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'mainCategory',
    default: 'none',
    displayName: 'Choose Main category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return ['none', ...adaptCategories(reportCategories.categories)] || [];
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'secondaryCategory',
    default: 'none',
    displayName: 'Choose Secondary category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return (
          ['none', ...adaptCategories(reportCategories.subcategories)] || []
        );
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
];
